import {
  PageContent,
  PageLayout,
  SubscriptionPageHeader,
  SubscriptionTabs,
} from '@subscriptions/presentation/components/base';
import { SubscriptionsListContent, PaymentHistoryContent } from '@subscriptions/presentation/components/specific';

/**
 * SubscriptionsPage - Main page for the Subscriptions domain
 *
 * Composes header + tabs within the domain PageLayout (store navigation top bar).
 * Each tab renders its own Content component which internally consumes hooks
 * and manages its own state.
 */
export const SubscriptionsPage = () => {
  return (
    <PageLayout>
      <PageContent className="min-w-0">
        <SubscriptionPageHeader />

        <SubscriptionTabs>
          <SubscriptionsListContent />
          <PaymentHistoryContent />
        </SubscriptionTabs>
      </PageContent>
    </PageLayout>
  );
};
